export default {
      id: "text-look-usage",
      viewBox: "0 0 182 17",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#text-look",
      toString: function () {
        return this.url;
      }
    }